export function getOAuthSettings(): {
  oauthUrl: string;
  clientId: string;
  oauthScopes: string[];
  microsoftClientId: string;
  microsoftAuthority: string;
  microsoftScopes: string[];
  microsoftRedirectUri: string;
  microsoftPostLogoutRedirectUri: string;
} {
  const firstNonEmpty = (...values: (string | undefined)[]): string | undefined =>
    values.find(value => typeof value === 'string' && value.trim().length > 0);

  const parseScopes = (rawScopes: string | undefined, fallback: string[]): string[] => {
    if (!rawScopes || rawScopes.trim().length === 0) {
      return fallback;
    }

    return rawScopes
      .split('|')
      .map(scope => scope.trim())
      .filter(scope => scope.length > 0);
  };

  const oauthScopes = parseScopes(import.meta.env.VITE_REACT_APP_OAUTH_SCOPES, [
    'openid',
    'offline_access',
    'Ydistri.Api',
    'Ydistri.Identity.Api',
  ]);

  const microsoftScopes = parseScopes(
    import.meta.env.VITE_REACT_APP_MICROSOFT_AUTH_SCOPES ??
      import.meta.env.VITE_REACT_APP_AUTH_SCOPES,
    ['User.Read'],
  );

  return {
    oauthUrl: firstNonEmpty(import.meta.env.VITE_REACT_APP_OAUTH_URL) ?? '',
    clientId:
      firstNonEmpty(
        import.meta.env.VITE_REACT_APP_OAUTH_CLIENT_ID,
        import.meta.env.VITE_REACT_APP_AUTH_CLIENT_ID,
      ) ?? '',
    oauthScopes,
    microsoftClientId:
      firstNonEmpty(
        import.meta.env.VITE_REACT_APP_MICROSOFT_CLIENT_ID,
        import.meta.env.VITE_REACT_APP_AUTH_CLIENT_ID,
      ) ?? '',
    microsoftAuthority:
      firstNonEmpty(
        import.meta.env.VITE_REACT_APP_MICROSOFT_AUTHORITY,
        import.meta.env.VITE_REACT_APP_AUTH_AUTHORITY,
      ) ?? 'https://login.microsoftonline.com/common',
    microsoftScopes,
    microsoftRedirectUri:
      firstNonEmpty(import.meta.env.VITE_REACT_APP_MICROSOFT_REDIRECT_URI) ??
      `${window.location.origin}/callback`,
    microsoftPostLogoutRedirectUri:
      firstNonEmpty(import.meta.env.VITE_REACT_APP_MICROSOFT_POST_LOGOUT_REDIRECT_URI) ??
      `${window.location.origin}/login`,
  };
}
